var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInprogressIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 779.46,
    height: 629.4,
    viewBox: "0 0 779.46 629.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-3 {\n        isolation: isolate;\n      }\n\n      .cls-4 {\n        clip-path: url(#clip-path-2);\n      }\n\n      .cls-5 {\n        fill: #fff;\n      }\n\n      .cls-6 {\n        clip-path: url(#clip-path-3);\n      }\n\n      .cls-7 {\n        mask: url(#mask);\n      }\n\n      .cls-8 {\n        clip-path: url(#clip-path-5);\n      }\n\n      .cls-10, .cls-9 {\n        fill: #96cdf7;\n      }\n\n      .cls-10 {\n        font-size: 125px;\n        font-family: Poppins-Bold, Poppins;\n        font-weight: 700;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 72.56,
    width: 629.36,
    height: 629.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 70.44,
    y: -4.5,
    width: 635.98,
    height: 634.78
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 779.46,
    height: 629.4
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 4.08,
    y: -50.54,
    width: 767.83,
    height: 735.03,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70.44,
    y: -4.5,
    width: 635.98,
    height: 634.78
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 13.44,
    y: -40.72,
    width: 749.09,
    height: 715.39,
    transform: "matrix(1, -0.03, 0.03, 1, -8.28, 10.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.59,
    y: 214.54,
    width: 745.33,
    height: 200.32,
    transform: "translate(-8.22 10.39) rotate(-1.52)"
  }))))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 72.56,
    width: 629.36,
    height: 629.4
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M287.28,613.27A314.85,314.85,0,0,1,158.9,98.17,312.61,312.61,0,0,1,378.9.11C552.36-4.5,697.2,132.89,701.81,306.34S569.06,624.68,395.61,629.28a314.81,314.81,0,0,1-108.33-16M482.73,28A302.2,302.2,0,0,0,179.32,534a300.32,300.32,0,0,0,216,82.81c166.56-4.43,298.46-143.55,294-310.11C685.85,176.28,599.83,67.1,482.73,28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M307.44,553.08A251.75,251.75,0,0,1,136.1,321.37c-3.68-138.48,106-254.14,244.48-257.82a251.24,251.24,0,0,1,189,424,251.94,251.94,0,0,1-262.13,65.5M463.68,86.44A240.78,240.78,0,0,0,380.87,74.2C248.25,77.72,143.22,188.48,146.74,321.09A240.46,240.46,0,1,0,463.68,86.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M341.15,453.11c-56.54-18.89-98.06-71.58-99.73-134.54a145.88,145.88,0,1,1,291.66-7.74c2.14,80.4-61.54,147.56-142,149.7a145.33,145.33,0,0,1-50-7.42m89.28-267.33a136,136,0,0,0-179,132.53c2,74.89,64.52,134.2,139.46,132.22S525.08,386,523.09,311.09a136.18,136.18,0,0,0-92.66-125.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M665,328.32l8.3-15.11-8.47-15,6.63-15.91-10.07-14,4.92-16.54-11.52-12.84,3.06-17-12.82-11.53,1.21-17.18-14-10.08-.66-17.2-15-8.51-2.52-17-15.84-6.82-4.35-16.69-16.46-5.07-6.11-16.11L554.4,92.44l-7.81-15.35-17.21-1.41-9.46-14.43-17.22.46L491.77,48.4l-17.1,2.3-12.35-12-16.69,4.14L432.09,32.16l-16.21,5.92L401.27,29l-15.46,7.64-15.53-7.46L355.74,38.4l-16.25-5.76L326.06,43.43l-16.77-4-12.2,12.18L280,49.49l-10.8,13.43L252,62.65l-9.31,14.51-17.15,1.59-7.67,15.43-16.89,3.44-6,16.18L178.52,119l-4.14,16.73-15.76,7-2.35,17.06-14.89,8.67-.51,17.22L127,195.94l1.37,17.17-12.67,11.65,3.21,16.93-11.34,13,5,16.47-9.89,14.11,6.78,15.85-8.27,15.1,8.46,15L103,347.1l10.06,14-4.89,16.52,11.51,12.85-3.06,16.95L129.45,419l-1.21,17.17,14,10.08.65,17.22,15,8.49L160.4,489l15.82,6.82,4.35,16.69L197,517.58l6.15,16.11,16.9,3.27,7.85,15.34,17.17,1.42,9.46,14.41,17.24-.44L282.74,581l17.09-2.32,12.3,12.07,16.75-4.15,13.54,10.64,16.2-5.94,14.61,9.13,15.47-7.64,15.53,7.48L418.74,591,435,596.76,448.43,586l16.77,4,12.21-12.17,17.13,2.13,10.79-13.41,17.23.26,9.29-14.51,17.15-1.6,7.69-15.43,16.88-3.45,6-16.15L596,510.36l4.17-16.73,15.77-7,2.34-17.05,14.9-8.66.51-17.23,13.84-10.21-1.34-17.2,12.69-11.64-3.24-16.92,11.35-13-5-16.48,9.88-14.11ZM394.3,579.88C247.84,583.77,126,468.2,122.08,321.74S233.75,53.41,380.21,49.52,648.53,161.2,652.42,307.65,540.74,576,394.3,579.88"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M9.49,427.45a6.25,6.25,0,0,1-4.26-5.77L0,225a6.25,6.25,0,0,1,6.08-6.41l761.74-19.44a6.24,6.24,0,0,1,6.41,6.09l5.23,196.67a6.27,6.27,0,0,1-1.72,4.46,6.2,6.2,0,0,1-4.37,1.95L11.64,427.76a6.16,6.16,0,0,1-2.15-.31m3.17-196.52,4.9,184.17L766.79,396,761.9,211.83Z"
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-10",
    transform: "translate(29.12 362.05) rotate(-1.46)"
  }, "In Progress"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInprogressIcon);
export default __webpack_public_path__ + "static/media/inprogress-icon.1397c59ce7c6c32a3916fe24b459e8e9.svg";
export { ForwardRef as ReactComponent };